import { render, staticRenderFns } from "./AddCategoryModal.vue?vue&type=template&id=37e02f1a&scoped=true&"
import script from "./AddCategoryModal.vue?vue&type=script&lang=js&"
export * from "./AddCategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./AddCategoryModal.vue?vue&type=style&index=0&id=37e02f1a&scoped=true&lang=scss&"
import style1 from "./AddCategoryModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e02f1a",
  null
  
)

export default component.exports